module.exports = __webpack_public_path__ + "static/img/digitaltwin2.e9a27e21.png";